// extracted by mini-css-extract-plugin
export default {"wrap":"PasswordInput_wrap__rq-3U","toggle":"PasswordInput_toggle__jf95Z"};